// Remembers which members list (filters + sort) an admin was browsing, so the prev/next arrows
// on a member's card walk exactly that list — and still work after a refresh or a bookmark.
const KEY = "so.admin.memberListCtx";

const TIER_LABEL = { standard: "VIP", pro: "PRO", premium: "CAPITAL", business: "TEAMS" };
const STATUS_LABEL = {
  active: "Active", suspended: "Suspended", pending_deletion: "Pending deletion", deleted: "Purged",
};
const SORT_LABEL = {
  recent: "newest first", oldest: "oldest first", name_asc: "by name (A–Z)",
  name_desc: "by name (Z–A)", tier: "by tier", status: "by status",
};

export function saveMemberListCtx(ctx) {
  try { sessionStorage.setItem(KEY, JSON.stringify(ctx || {})); } catch { /* private mode */ }
}

export function readMemberListCtx() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

/** Only the filters the members list itself applies — nothing else reaches the API. */
export function ctxParams(ctx) {
  const c = ctx || {};
  const params = { sort: c.sort || "recent" };
  if (c.q) params.q = c.q;
  if (c.tier && c.tier !== "all") params.tier = c.tier;
  if (c.status && c.status !== "all") params.status = c.status;
  if (c.tag && c.tag !== "all") params.tag = c.tag;
  return params;
}

/** "CAPITAL · Active · by name (A–Z)" — so the arrows are never ambiguous. */
export function ctxLabel(ctx, tagNames = {}) {
  const c = ctx || {};
  const bits = [];
  if (c.q) bits.push(`“${c.q}”`);
  if (c.tier && c.tier !== "all") bits.push(TIER_LABEL[c.tier] || c.tier);
  if (c.status && c.status !== "all") bits.push(STATUS_LABEL[c.status] || c.status);
  if (c.tag && c.tag !== "all") bits.push(tagNames[c.tag] || "tagged");
  bits.push(SORT_LABEL[c.sort || "recent"] || c.sort);
  return bits.join(" · ");
}
